import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {readCookie} from '@Utils/cookie.util';
import {SUBSCRIPTION_PROMOTION_CODE_COOKIE} from '@Panels/premium-pricing-panel/premium-pricing-panel.types';

/**
 * An explicitly passed code takes precedence over the one a `?promo=` landing left behind, so a caller
 * that knows which offer it is upselling always wins over an older ambient cookie.
 */
const getPromoCodeToApply = (promoCode?: string): string => {
  if (promoCode !== undefined && promoCode !== '') {
    return promoCode;
  }

  return readCookie(SUBSCRIPTION_PROMOTION_CODE_COOKIE) ?? '';
};

export const openPremiumPricingModal = (isTrial: boolean, upsellFeatureName?: string, promoCode?: string, trialSource?: string): void => {
  const modalId = MODALS_IDS.PREMIUM_PRICING_MODAL;

  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: modalId,
      panelProps: {
        modalId: modalId,
        isTrial: isTrial,
        upsellFeatureName: upsellFeatureName,
        promoCode: getPromoCodeToApply(promoCode),
        trialSource: trialSource,
      },
    })
  );
};
